var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSCause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 467,
    viewBox: "0 0 465 467",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M465 170.797V425.633L423.807 467H0V362.948H232.5C236.05 362.948 239.037 361.854 241.462 359.63C243.888 357.406 245.118 354.724 245.118 351.618V350.276C245.118 346.712 243.782 343.711 241.146 341.276C238.51 338.841 235.382 337.605 231.832 337.605H41.1927L0 296.238V41.3668L41.1927 0H465V104.052H233.168C229.618 104.052 226.525 105.288 223.854 107.723C221.182 110.158 219.882 113.159 219.882 116.724V118.065C219.882 121.171 221.112 123.853 223.537 126.077C225.963 128.301 228.95 129.395 232.5 129.395H423.807L465 170.762V170.797Z",
    fill: "#FEFEE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSCause);
export default __webpack_public_path__ + "static/media/S-Cause.39881363625308528d40fa43d5d430d5.svg";
export { ForwardRef as ReactComponent };